<template>
	<div class="step_container">
		<el-form ref="form" :model="secondStepForm" :rules="rules" :inline="inline" :label-width="labelWidth" :label-position="labelPosition" size="mini">
		  <el-form-item label="任务名称" prop="task_title">
		    <el-input v-model="secondStepForm.task_title" show-word-limit :maxlength="20" clearable placeholder="输入任务名称"></el-input>
		  </el-form-item>
      <el-form-item label="任务介绍" prop="task_desc">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" show-word-limit :maxlength="200" placeholder="请输入任务介绍" v-model="secondStepForm.task_desc"/>
      </el-form-item>
      <el-form-item label="任务类型" prop="task_type">
        <el-radio-group v-model="secondStepForm.task_type" @change="changeTaskType">
          <el-radio :label="item.id" v-for="(item,index) in typeList.taskTypeList" :key="index">{{item.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
		  <el-form-item label="任务时长" prop="task_time">
		    <el-radio-group v-model="secondStepForm.task_time" @change="changeDuration">
		      <el-radio :label="item.id" v-for="(item,index) in typeList.durationList" :key="index">{{item.label}}</el-radio>
		    </el-radio-group>
		  </el-form-item>
		  <el-form-item label="步骤引导">
        <div class="step_boxs">
          <div class="position_steps_view" v-for="(item,index) in secondStepForm.task_step_guide" :key="index">
            <div class="indexes">{{index + 1}}</div>
            <div class="step_view">
              <el-input class="step_views_item_input" show-word-limit :maxlength="200" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入完成任务的步骤说明" v-model="item.desc"/>
              <el-link type="primary" :underline="false" icon="el-icon-delete" @click="toDeleteStep(index)">删除</el-link>
            </div>
            <div class="step_view">
              <el-input class="step_views_item_input" v-model="item.url" clearable placeholder="请输入链接地址：如：http://www.lucasgc.com"></el-input>
            </div>
            <div class="step_view">
              <upload-image v-model="item.images"></upload-image>
            </div>
            <div class="step_view">
              <el-checkbox v-model="item.isText" @change="needTextImage($event,index,1)">需要用户提交规定文字</el-checkbox>
              <template v-if="item.isText">
                <div class="step_views_item" v-for="(text,t) in item.rules" :key="t">
                  <template v-if="text.type == 1">
                    <el-input class="step_views_item_input" show-word-limit :maxlength="50" v-model="text.text" clearable placeholder="请描述提交文字，例如：手机号；如需多条请新增"></el-input>
                    <el-link type="primary" :underline="false" icon="el-icon-delete" @click="toDeleteStrip(index,t,1)">删除</el-link>
                  </template>
                </div>
              </template>
              <div v-if="item.isText">
                <el-link type="primary" :underline="false" icon="el-icon-plus" @click="toAddStrip(index,1)">新增</el-link>
              </div>
            </div>
            <div class="step_view">
              <el-checkbox v-model="item.isImage" @change="needTextImage($event,index,2)">需要用户提交规定图片</el-checkbox>
              <template v-if="item.isImage">
                <div class="step_views_item" v-for="(img,g) in item.rules" :key="g">
                  <template v-if="img.type == 2">
                    <el-input class="step_views_item_input" v-model="img.text" clearable placeholder="请描述提交文字，例如：手机号；如需多条请新增"></el-input>
                    <!-- <el-link type="primary" :underline="false" icon="el-icon-delete" @click="toDeleteStrip(index,g,2)">删除</el-link> -->
                    <upload-image class="mar_t" v-model="img.img"></upload-image>
                  </template>
                </div>
              </template>
              <!-- <div v-if="item.isImage">
                <el-link type="primary" :underline="false" icon="el-icon-plus" @click="toAddStrip(index,2)">新增</el-link>
              </div> -->
            </div>
          </div>
          <el-link type="primary" :underline="false" icon="el-icon-edit" @click="toAddStep">添加步骤</el-link>
        </div>
		  </el-form-item>
		  <el-form-item size="large">
        <slot name="handle"></slot>
		  </el-form-item>
		</el-form>
	</div>
</template>

<script>
	import uploadImage from './upload.vue'
  import "@/shared/plugins/element"
	export default {
		components:{uploadImage},
		props:{
			//表单元素是并列同行还是独占一行
			inline:{
				type:Boolean,
				default:false
			},
			//表单标签宽度
			labelWidth:{
				type:String,
				default:'85px'
			},
      //表单标签位置
			labelPosition:{
				type:String,
				default:'left'
			},
      //类型
      typeList:{
        type:Object,
        default:()=>{}
      },
			//绑定的表单
			secondStepForm:{
				type:Object,
				default:()=>{}
			},
      //校验规则
      rules:{
      	type:Object,
      	default:()=>{}
      },
		},
		data(){
			return {
				
			}
		},
		methods:{
			// 表单验证
			async submitForm(prop) {
				try {
					return await this.$refs["form"].validate();
				} catch (error) {
					return error;
				}
			},
      //更改任务类型
      changeTaskType(id){
        this.$emit('changeTaskType',id)
      },
      //更改任务时长
      changeDuration(id){
        this.$emit('changeDuration',id)
      },
      //添加步骤
      toAddStep(){
        this.$emit('toAddStep',this.secondStepForm.task_step_guide.length)
      },
      //删除步骤
      toDeleteStep(index){
        this.$emit('toDeleteStep',index)
      },
      //需要用户提交规定文字
      needTextImage(val,index,type){
        let obj = {
          val:val,
          index:index,
          type:type
        }
        this.$emit('needTextImage',obj)
      },
      //新增条目
      toAddStrip(index,type){
        let obj = {
          index:index,
          type:type
        }
        this.$emit('toAddStrip',obj)
      },
      //删除条目
      toDeleteStrip(index,t,type){
        let obj = {
          index:index,
          textIndex:t,
          type:type
        }
        this.$emit('toDeleteStrip',obj)
      },
		}
	}
</script>

<style scoped="scoped">
  .step_view{ margin-bottom: 10px; }
  .step_boxs{ padding-top: 40px; }
  .position_steps_view{ position: relative;}
  .position_steps_view .indexes{ position: absolute;left: -35px;top: 10px;width: 25px;height: 25px;
    border-radius: 50%;line-height: 25px;color: #fff;font-size: 14px;background: #1989FF;text-align: center; }
  .step_views_item{ margin-bottom: 10px; }
  .step_views_item_input{ width: 400px; margin-right: 15px; }
  .mar_t{margin-top: 10px;}
  .step_container >>> .el-form-item--mini .el-form-item__error{ padding-top: 3px!important; }
</style>
